import jwt_decode from "jwt-decode";
import React from "react";
import strings from "../config/localization";

function isPermissionExistsGeneric(accessToken: string, permission: string) {
  if (accessToken) {
    const payload: any = jwt_decode(accessToken);
    for (let i = 0; i < payload?.roles?.length; i++) {
      if (payload?.roles[i]?.permissions?.includes(permission)) {
        return true;
      }
    }
    return false;
  } else {
    return false;
  }
}

function isRoleExistsGeneric(accessToken: string, role: string) {
  if (accessToken) {
    const payload: any = jwt_decode(accessToken);
    for (let i = 0; i < payload?.roles?.length; i++) {
      if (payload?.roles[i]["name"] === role) {
        return true;
      }
    }
    return false;
  } else {
    return false;
  }
}

export function doesPermissionExist(permission: string) {
  const accessToken = localStorage.getItem("accessToken");
  return isPermissionExistsGeneric(accessToken!, permission);
}

export function doesRoleExist(role: string) {
  const accessToken = localStorage.getItem("accessToken");
  return isRoleExistsGeneric(accessToken!, role);
}

export function removeEmptyKeys(obj: any) {
  const newObj: any = {};
  for (const key in obj) {
    console.log("key = ", key, "value = ", obj[key]);
    if (obj[key] && (obj[key] !== "" || obj[key] !== 0)) {
      console.log("ADding key = ", key, "value = ", obj[key]);
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

export function getLabel(props: any, lang: string, fallback: string) {
  if (lang in props) {
    return props[lang];
  }

  if (fallback in props) {
    return props[fallback];
  }

  return "";
}

export function setDifference(a: string[], b: string[]): string[] {
  // return A - B (elements only in A and not in B)
  const bSet = new Set<string>();
  b.forEach((e) => bSet.add(e));
  const result: string[] = [];
  a.forEach((e) => {
    if (!bSet.has(e)) {
      result.push(e);
    }
  });
  return result;
}

export function isNumeric(value: string) {
  return /^\d+$/.test(value);
}

export function isPositive(value: string) {
  return isNumeric(value) && +value > 0;
}

export function getLocationStrMap() {
  return new Map<string, string>([
    ["range", strings.range],
    ["area", strings.area],
    ["subarea", strings.subarea],
    ["point", strings.point],
  ]);
}

export function getLocationKinds() {
  return [strings.range, strings.area, strings.subarea, strings.point].sort();
}

export function getLocationFilters() {
  return [
    {
      text: strings.range,
      value: strings.range,
    },
    {
      text: strings.area,
      value: strings.area,
    },
    {
      text: strings.subarea,
      value: strings.subarea,
    },
    {
      text: strings.point,
      value: strings.point,
    },
  ];
}

export function getUpdatePermission(kind: string) {
  if (kind === "range") {
    return "bandobast_ranges_update";
  }
  if (kind === "area") {
    return "bandobast_areas_update";
  }
  if (kind === "subarea") {
    return "bandobast_subareas_update";
  }
  if (kind === "point") {
    return "bandobast_points_update";
  }
}

export function getDeletePermission(kind: string) {
  if (kind === "range") {
    return "bandobast_ranges_remove";
  }
  if (kind === "area") {
    return "bandobast_areas_remove";
  }
  if (kind === "subarea") {
    return "bandobast_subareas_remove";
  }
  if (kind === "point") {
    return "bandobast_points_remove";
  }
}

export function getReverseLocationStrMap() {
  return new Map<string, string>([
    [strings.range, "range"],
    [strings.area, "area"],
    [strings.subarea, "subarea"],
    [strings.point, "point"],
  ]);
}

export function getParentLocationType(kind: string) {
  const map = new Map<string, string>([
    [strings.range, ""],
    [strings.area, strings.range],
    [strings.subarea, strings.area],
    [strings.point, strings.subarea],
  ]);
  return map.get(kind)!;
}

export function convertDate(dateStr: string) {
  const language: string = localStorage.getItem("language") || "en";
  // converts yyyy-mm-dd to dd-mm-yyyy
  if (dateStr === undefined || dateStr === null || dateStr === "") {
    return dateStr;
  }
  return dateStr.split("-").reverse().join("-").toLocaleLowerCase(language);
}

export function convertTimestamp(timestamp: string) {
  // converts yyyy-mm-dd hh:mm:ss to dd-mm-yyyy hh:mm:ss
  if (timestamp === undefined || timestamp === null || timestamp === "") {
    return timestamp;
  }

  const fields = timestamp.split(" ");
  const dateStr = convertDate(fields[0]);
  return `${dateStr} ${fields[1]}`;
}

export function convertDate2(dateStr: string) {
  const language: string = localStorage.getItem("language") || "en";
  // converts yyyy-mm-dd to dd/mm/yyyy
  if (dateStr === undefined || dateStr === null || dateStr === "") {
    return dateStr;
  }
  return dateStr.split("-").reverse().join("/").toLocaleLowerCase(language);
}

export function isObjectEmpty(obj: any) {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}

// returns todays date in format yyyy-mm-dd
export function getTodaysDate() {
  const date = new Date();
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function useDebounce(effect: any, dependencies: any, delay: number) {
  const callback = React.useCallback(effect, dependencies);

  React.useEffect(() => {
    const timeout = setTimeout(callback, delay);
    return () => clearTimeout(timeout);
  }, [callback, delay]);
}
